import { render, staticRenderFns } from "./EventsDayWidget.vue?vue&type=template&id=802bbbe8"
import script from "./EventsDayWidget.vue?vue&type=script&lang=js"
export * from "./EventsDayWidget.vue?vue&type=script&lang=js"
import style0 from "./EventsDayWidget.vue?vue&type=style&index=0&id=802bbbe8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports